import { QuickRefEntry } from '../types';

export const carcassonneQuickRef: QuickRefEntry[] = [
  {
    "id": "qr-base",
    "title": "Ściąga — podstawa",
    "requiredModuleIds": [
      "base"
    ],
    "blocks": [
      {
        "type": "bulletList",
        "items": [
          "Pełna tabela punktowania — u góry tej ściągi (filtrowana po aktywnych dodatkach).",
          "Tabela pionków i figurek — poniżej punktowania (filtrowana po aktywnych dodatkach).",
          "Tura: kafelek → figura → scoring",
          "Remis = pełne punkty"
        ]
      }
    ]
  },
  {
    "id": "qr-m1",
    "title": "Ściąga — Karczmy i Katedry",
    "requiredModuleIds": [
      "major-01-inns-cathedrals"
    ],
    "blocks": [
      {
        "type": "editionWarning",
        "text": "C3.1 ≠ stare zero",
        "oldEditionName": "stare zero"
      },
      {
        "type": "paragraph",
        "text": "Karczma 2 ukończona / 1 nie; katedra 3; duży meeple siła 2"
      }
    ]
  },
  {
    "id": "qr-m2",
    "title": "Ściąga — Kupcy i Budowniczowie",
    "requiredModuleIds": [
      "major-02-traders-builders"
    ],
    "blocks": [
      {
        "type": "editionWarning",
        "text": "C3.1 ≠ świnia końcowa",
        "oldEditionName": "świnia końcowa"
      },
      {
        "type": "paragraph",
        "text": "Towary dla kończącego; budowniczy wraca przed double; świnia po herbie"
      }
    ]
  },
  {
    "id": "qr-m3",
    "title": "Ściąga — Wróżka i Smok",
    "requiredModuleIds": [
      "major-03-dragon-fairy"
    ],
    "blocks": [
      {
        "type": "editionWarning",
        "text": "C3.1 ≠ Księżniczka i Smok",
        "oldEditionName": "Księżniczka i Smok"
      },
      {
        "type": "paragraph",
        "text": "Smok: 2 proste ruchy; wróżka; portal"
      }
    ]
  },
  {
    "id": "qr-m4",
    "title": "Ściąga — Wieże i Złodzieje",
    "requiredModuleIds": [
      "major-04-towers-thieves"
    ],
    "blocks": [
      {
        "type": "editionWarning",
        "text": "C3.1 ≠ Wieża",
        "oldEditionName": "Wieża"
      },
      {
        "type": "paragraph",
        "text": "Strażnicy, zasięg=piętra; bez porywania"
      }
    ]
  },
  {
    "id": "qr-m5",
    "title": "Ściąga — Kurierzy i Burmistrzowie",
    "requiredModuleIds": [
      "major-05-messengers-mayors"
    ],
    "blocks": [
      {
        "type": "editionWarning",
        "text": "C3.1 ≠ Opactwo i Burmistrz",
        "oldEditionName": "Opactwo i Burmistrz"
      },
      {
        "type": "paragraph",
        "text": "Ratusz; burmistrz 0; kurier; strach"
      }
    ]
  },
  {
    "id": "qr-m6",
    "title": "Ściąga — Turnieje i Godła",
    "requiredModuleIds": [
      "major-06-jousts-crests"
    ],
    "blocks": [
      {
        "type": "editionWarning",
        "text": "C3.1 ≠ Hrabia Król Rzeka",
        "oldEditionName": "Hrabia Król Rzeka"
      },
      {
        "type": "paragraph",
        "text": "Nominacje; nagrody; 3×herb na posągu"
      }
    ]
  },
  {
    "id": "qr-m7",
    "title": "Ściąga — Oblężenie i Obrona",
    "requiredModuleIds": [
      "major-07-siege-defense"
    ],
    "blocks": [
      {
        "type": "editionWarning",
        "text": "C3.1 ≠ Katapulta",
        "oldEditionName": "Katapulta"
      },
      {
        "type": "paragraph",
        "text": "Kontratak 3×; atak; twierdza=miasto"
      }
    ]
  },
  {
    "id": "qr-m8",
    "title": "Ściąga — Zamki i Mosty",
    "requiredModuleIds": [
      "major-08-castles-bridges"
    ],
    "blocks": [
      {
        "type": "editionWarning",
        "text": "C3.1 ≠ Bazary",
        "oldEditionName": "Bazary"
      },
      {
        "type": "paragraph",
        "text": "1 budynek/turę; most 3/1; dama; stodoła"
      }
    ]
  },
  {
    "id": "qr-m9",
    "title": "Ściąga — Pasterze i Owce",
    "requiredModuleIds": [
      "major-09-sheep-shepherds"
    ],
    "blocks": [
      {
        "type": "editionWarning",
        "text": "C3.1 ≠ Wzgórza i Owce",
        "oldEditionName": "Wzgórza i Owce"
      },
      {
        "type": "paragraph",
        "text": "Wilk; wypas pełny; gęsi; winnice; bez wzgórz"
      }
    ]
  },
  {
    "id": "qr-m10",
    "title": "Ściąga — Cyrk i Artyści",
    "requiredModuleIds": [
      "major-10-circus-artists"
    ],
    "blocks": [
      {
        "type": "editionWarning",
        "text": "C3.1 ≠ Under the Big Top",
        "oldEditionName": "Under the Big Top"
      },
      {
        type: 'paragraph',
        text: 'Występ bez usuwania; piramida 5; dyrektorka +2'
      }
    ]
  },
  {
    id: 'qr-mists-coop',
    title: 'Ściąga — Mgła (kooperacja)',
    requiredModuleIds: ['mists-over-carcassonne'],
    requiredMistsPlayMode: 'coop',
    blocks: [
      {
        type: 'paragraph',
        text: 'Tura: 1a kafelek (mgłę ignoruj) → 1b zamknij mgłę → 2a duchy (−1 przy rozszerzeniu) → 2b meeple (bez pól) → 3 punkty LUB −3 duchy z 1 kafelka.',
      },
      {
        type: 'paragraph',
        text: 'Przegrana: brak duchów przy wystawieniu lub brak kafelków przed celem. Bez farmerów i bez scoringu końcowego pól.',
      },
      {
        type: 'bulletList',
        items: [
          'L1: 50 pkt · 15 duchów · bez zamków/cmentarzy',
          'L2: 75 (2×25) · zamki + cmentarze (4 boki)',
          'L3–4: 3 stosy ×20 · psy Rufus/Ronja · L4: 13 duchów',
          'L5–6: nawiedzony cmentarz (8) · L6: progi per kolor',
        ],
      },
    ],
  },
  {
    id: 'qr-mists-classic',
    title: 'Ściąga — Duchy/Zamki/Cmentarze (klasyka)',
    requiredModuleIds: ['mists-over-carcassonne'],
    requiredMistsPlayMode: 'classic-expansion',
    blocks: [
      {
        type: 'paragraph',
        text: 'Rozszerzanie mgły → duch na meepla przeciwnika. Ograniczanie → duch na własnego. −2 pkt / duch przy scoringu; 3. duch zdejmuje meepla. Strażnicy odporni.',
      },
      {
        type: 'paragraph',
        text: 'Cmentarz otoczony (8) → strażnik z zapasu + zwrot keepers. Zamek: 2 pkt / sąsiad z mgłą. Farmerzy OK; finał: −1 / duch na meeplach.',
      },
    ],
  },
];
